import { post } from "../../../services/request";

export const getCommunications = (data) => post('Document/GetDocumentFileMappingList', data);
export const getNotifications = (data) => post('Document/GetNotificationTypeFileMappingList', data);
export const getCommunicationNotification = (data) => post('Document/GetCommunicationNotification', data);
export const getAllOtherCommunications = (data) => post('Document/GetAllOtherCommunications', data);
export const saveNotificationViewLog = (data) => post('Document/SaveNotificationViewLog', data);